import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { FaUser, FaHeartbeat, FaLeaf, FaBrain, FaPhoneAlt, FaMapMarkerAlt, FaChevronRight, FaCheckCircle, FaTimes } from 'react-icons/fa';
//import LocationPicker from 'ProfileSetup/Locationpicker';
import LocationPicker from '../ProfileSetup/Locationpicker';

// ═══════════════════════════════════════════════════════════════
// PWA STYLES
// ═══════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════
// PWA STYLES (FIXED MODAL OVERFLOW)
// ═══════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════
// PWA STYLES (BULLETPROOF SCROLLING MODAL)
// ═══════════════════════════════════════════════════════════════
const css = `
  .hh-profile-root {
    font-family: var(--font, 'Plus Jakarta Sans', sans-serif);
    background: var(--bg, #F9F4F0);
    color: var(--ink, #2D364D);
    min-height: 100vh;
    padding-bottom: 40px;
    padding-top: calc(env(safe-area-inset-top, 0px) + 20px);
    position: relative;
  }

  /* Header & Cards (Unchanged) */
  .hh-p-header { display: flex; align-items: center; justify-content: space-between; padding: 0 20px 20px; position: sticky; top: 0; z-index: 10; background: var(--bg, #F9F4F0); }
  .hh-p-back { background: var(--card, #fff); border: 1.5px solid var(--sand-light, #EBE7DF); color: var(--ink); padding: 8px 16px; border-radius: 20px; font-weight: 700; font-size: .9rem; cursor: pointer; box-shadow: var(--sh-input); }
  .hh-p-title { font-family: var(--font-display, serif); font-size: 1.5rem; font-weight: 700; }
  .hh-completion-card { margin: 0 20px 24px; background: var(--brand, #5A6993); color: #fff; border-radius: 20px; padding: 20px; box-shadow: 0 8px 24px rgba(90,105,147,0.2); position: relative; overflow: hidden; }
  .hh-completion-card::after { content: ''; position: absolute; top: -50%; right: -20%; width: 150px; height: 150px; background: rgba(255,255,255,0.1); border-radius: 50%; blur: 20px; }
  .hh-comp-title { font-size: 1.1rem; font-weight: 700; margin-bottom: 6px; display: flex; align-items: center; gap: 8px; }
  .hh-comp-sub { font-size: 0.85rem; opacity: 0.9; margin-bottom: 16px; line-height: 1.4; }
  .hh-comp-track { height: 6px; background: rgba(255,255,255,0.2); border-radius: 10px; overflow: hidden; }
  .hh-comp-fill { height: 100%; background: #fff; border-radius: 10px; transition: width 0.8s cubic-bezier(0.22, 1, 0.36, 1); }
  .hh-p-sections { padding: 0 20px; display: flex; flex-direction: column; gap: 16px; }
  .hh-p-card { background: var(--card, #fff); border-radius: 20px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); border: 1px solid var(--sand-light, #EBE7DF); cursor: pointer; transition: transform 0.2s ease; }
  .hh-p-card:active { transform: scale(0.98); }
  .hh-p-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
  .hh-p-card-title { display: flex; align-items: center; gap: 10px; font-weight: 700; font-size: 1.05rem; }
  .hh-p-icon-wrap { width: 36px; height: 36px; border-radius: 12px; display: flex; align-items: center; justify-content: center; background: var(--brand-wash, rgba(90,105,147,0.1)); color: var(--brand, #5A6993); }
  .hh-p-status { font-size: 0.8rem; font-weight: 600; color: var(--sage, #7B8F8A); display: flex; align-items: center; gap: 4px; }
  .hh-p-status.missing { color: var(--peach, #E6A184); }
  .hh-p-summary { font-size: 0.9rem; color: var(--muted, #9C8474); line-height: 1.5; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

  /* ─── BULLETPROOF MODAL ─── */
  .hh-edit-modal {
    position: absolute; top: 0; left: 0; width: 100%; min-height: 100%; 
    z-index: 99999; background: var(--card, #fff);
    animation: slideUp 0.3s cubic-bezier(0.22, 1, 0.36, 1);
  }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  
  .hh-em-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: calc(env(safe-area-inset-top, 0px) + 20px) 20px 20px;
    border-bottom: 1px solid var(--sand-light, #EBE7DF);
    background: var(--card);
    position: sticky; top: 0; z-index: 2;
  }
  .hh-em-cancel { background: none; border: none; color: var(--muted); font-size: 1.2rem; cursor: pointer; padding: 8px; }
  .hh-em-title { font-weight: 700; font-size: 1.1rem; }
  .hh-em-header-spacer { width: 36px; }

  .hh-em-body { padding: 24px 20px 60px; }
  
  .hh-field { margin-bottom: 20px; }
  .hh-label { display: block; font-size: 0.75rem; font-weight: 700; color: var(--muted); margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.05em; }
  .hh-input {
    width: 100%; padding: 14px 16px; font-family: inherit; font-size: 0.95rem; font-weight: 500;
    background: var(--cloud, #F4F7F9); color: var(--ink); border: 1.5px solid var(--sand-light);
    border-radius: 12px; outline: none; transition: all 0.2s ease;
  }
  .hh-input:focus { border-color: var(--brand-light, #A1B0D8); background: var(--card); box-shadow: 0 0 0 4px var(--brand-wash); }
  
  /* Button directly in the flow */
  .hh-submit-btn {
    width: 100%; padding: 16px; background: var(--brand, #5A6993); color: #fff;
    border: none; border-radius: 16px; font-family: inherit; font-size: 1rem;
    font-weight: 700; cursor: pointer; transition: opacity 0.2s;
    margin-top: 12px;
  }
  .hh-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .hh-submit-btn:active:not(:disabled) { transform: scale(0.98); }

  .hh-loading { display: flex; height: 100vh; align-items: center; justify-content: center; font-weight: 600; color: var(--muted); }
`;

// ═══════════════════════════════════════════════════════════════
// DEFAULT SCHEMA & CONFIG
// ═══════════════════════════════════════════════════════════════
const DEFAULT_SCHEMA = {
  basicInfo: { firstName: '', lastName: '', age: '', gender: '', email: '', phone: '', city: '', country: '', college: '' },
  healthInfo: { bloodGroup: '', allergies: '', medicalConditions: '', ongoingMedications: '' },
  lifestyleInfo: { dietPreference: '', exerciseRoutine: '', sleepHours: '', smokingHabits: '', alcoholHabits: '' },
  mentalWellbeing: { stressLevel: '5' },
  emergencyContact: { name: '', relation: '', phoneNumber: '' },
  location: { formattedAddress: '', lat: null, lng: null }
};

const SECTIONS = [
  { id: 'basicInfo', title: 'Basic Information', icon: <FaUser />, fields: [
    { name: 'firstName', label: 'First Name' }, { name: 'lastName', label: 'Last Name' },
    { name: 'age', label: 'Age', type: 'number' }, { name: 'gender', label: 'Gender' },
    { name: 'email', label: 'Email', type: 'email' }, { name: 'phone', label: 'Phone' },
    { name: 'city', label: 'City' }, { name: 'country', label: 'Country' }, { name: 'college', label: 'College / Workplace' }
  ]},
  { id: 'healthInfo', title: 'Health & Medical', icon: <FaHeartbeat />, fields: [
    { name: 'bloodGroup', label: 'Blood Group' }, { name: 'allergies', label: 'Allergies (Comma separated)' },
    { name: 'medicalConditions', label: 'Medical Conditions' }, { name: 'ongoingMedications', label: 'Ongoing Medications' }
  ]},
  { id: 'lifestyleInfo', title: 'Lifestyle & Habits', icon: <FaLeaf />, fields: [
    { name: 'dietPreference', label: 'Dietary Preference' }, { name: 'exerciseRoutine', label: 'Exercise Routine (e.g., 3x week)' },
    { name: 'sleepHours', label: 'Average Sleep (Hours)', type: 'number' }, { name: 'smokingHabits', label: 'Smoking Habits' },
    { name: 'alcoholHabits', label: 'Alcohol Habits' }
  ]},
  { id: 'mentalWellbeing', title: 'Mental Baseline', icon: <FaBrain />, fields: [
    { name: 'stressLevel', label: 'Current Stress Level (1-10)', type: 'number' }
  ]},
  { id: 'emergencyContact', title: 'Emergency Contact', icon: <FaPhoneAlt />, fields: [
    { name: 'name', label: 'Contact Name' }, { name: 'relation', label: 'Relation to you' },
    { name: 'phoneNumber', label: 'Phone Number' }
  ]},
  { id: 'location', title: 'Location', icon: <FaMapMarkerAlt />, fields: [
    { name: 'formattedAddress', label: 'Full Address' }
  ]}
];

// ═══════════════════════════════════════════════════════════════
// COMPONENT
// ═══════════════════════════════════════════════════════════════
export default function MyProfile() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [activeSection, setActiveSection] = useState(null);
  const [formState, setFormState] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const dbData = docSnap.data();
          let normalizedData = { ...DEFAULT_SCHEMA, ...dbData };

          // Bridge for data created during ProfileSetupPage
          if (dbData.profile && !dbData.basicInfo?.firstName) {
            normalizedData.basicInfo.firstName = dbData.profile.firstName || '';
            normalizedData.basicInfo.lastName = dbData.profile.lastName || '';
            normalizedData.basicInfo.age = dbData.profile.age || '';
            normalizedData.basicInfo.gender = dbData.profile.gender || '';
            normalizedData.mentalWellbeing.stressLevel = dbData.profile.stressLevel || '5';
            normalizedData.emergencyContact.name = dbData.profile.emergencyName || '';
            normalizedData.emergencyContact.relation = dbData.profile.emergencyRelation || '';
            normalizedData.emergencyContact.phoneNumber = dbData.profile.emergencyContact || '';
            
            await setDoc(docRef, normalizedData, { merge: true });
          }
          
          setData(normalizedData);
        } else {
          setData(DEFAULT_SCHEMA);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const { completionPct } = useMemo(() => {
    if (!data) return { completionPct: 0 };
    let filled = 0;
    let total = 0;
    
    SECTIONS.forEach(sec => {
      sec.fields.forEach(f => {
        total++;
        if (data[sec.id]?.[f.name] && String(data[sec.id][f.name]).trim() !== '') {
          filled++;
        }
      });
    });

    return { completionPct: Math.round((filled / total) * 100) };
  }, [data]);

  const openEditModal = (sectionId) => {
    setFormState(data[sectionId] || {});
    setActiveSection(sectionId);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleLocationSelect = (locData) => {
    setFormState(prev => ({
      ...prev,
      formattedAddress: locData.address,
      lat: locData.lat,
      lng: locData.lng
    }));
  };

  const handleSave = async (e) => {
    if (e) e.preventDefault(); // Prevent page reload if submitted via form Enter key
    if (!auth.currentUser || !activeSection) return;
    
    setSaving(true);
    try {
      const docRef = doc(db, 'users', auth.currentUser.uid);
      
      // Using setDoc with merge:true is safer than updateDoc for nested objects
      // It creates the parent object if it doesn't exist yet
      await setDoc(docRef, { [activeSection]: formState }, { merge: true });
      
      // Update local state instantly
      setData(prev => ({ ...prev, [activeSection]: formState }));
      setActiveSection(null);
    } catch (err) {
      console.error('Save error:', err);
      alert('Failed to save changes. Please check your connection and try again.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="hh-loading">Loading your space...</div>;
  if (!data) return <div className="hh-loading">No profile data found.</div>;

  const activeSectionConfig = SECTIONS.find(s => s.id === activeSection);

  return (
    <>
      <style>{css}</style>
      <div className="hh-profile-root">
        
        <div className="hh-p-header">
          <button className="hh-p-back" onClick={() => navigate(-1)}>← Back</button>
          <div className="hh-p-title">Profile</div>
          <div style={{ width: 60 }} />
        </div>

        <div className="hh-completion-card">
          <div className="hh-comp-title">
            {completionPct === 100 ? 'Profile Complete 🎉' : 'Complete Your Profile'}
          </div>
          <div className="hh-comp-sub">
            {completionPct === 100 
              ? "Your HealHub space is fully personalized." 
              : `You are ${completionPct}% done. Add more details to get better insights and tailored recommendations.`}
          </div>
          <div className="hh-comp-track">
            <div className="hh-comp-fill" style={{ width: `${completionPct}%` }} />
          </div>
        </div>

        <div className="hh-p-sections">
          {SECTIONS.map((sec) => {
            const sectionData = data[sec.id] || {};
            const isComplete = sec.fields.every(f => sectionData[f.name] && String(sectionData[f.name]).trim() !== '');
            
            const summaryValues = sec.fields
              .map(f => sectionData[f.name])
              .filter(val => val && String(val).trim() !== '')
              .slice(0, 3)
              .join(' · ');

            return (
              <div key={sec.id} className="hh-p-card" onClick={() => openEditModal(sec.id)}>
                <div className="hh-p-card-header">
                  <div className="hh-p-card-title">
                    <div className="hh-p-icon-wrap">{sec.icon}</div>
                    {sec.title}
                  </div>
                  <div className={`hh-p-status ${isComplete ? '' : 'missing'}`}>
                    {isComplete ? <><FaCheckCircle /> Complete</> : 'Needs Info'} <FaChevronRight style={{ marginLeft: 4, color: 'var(--sand)' }}/>
                  </div>
                </div>
                <div className="hh-p-summary">
                  {summaryValues || 'Tap to add information...'}
                </div>
              </div>
            );
          })}
        </div>

        {/* ─── FULL SCREEN EDIT MODAL ─── */}
        {activeSection && activeSectionConfig && (
          <div className="hh-edit-modal">
            <div className="hh-em-header">
              <button type="button" className="hh-em-cancel" onClick={() => setActiveSection(null)}>
                <FaTimes />
              </button>
              <div className="hh-em-title">{activeSectionConfig.title}</div>
              <div className="hh-em-header-spacer" />
            </div>
            
            <form className="hh-em-body" onSubmit={handleSave}>
              {activeSectionConfig.fields.map(field => {
                // Render LocationPicker + Standard Input sync for the Location tab
                if (activeSection === 'location' && field.name === 'formattedAddress') {
                  return (
                    <div key={field.name} className="hh-field">
                      <label className="hh-label">{field.label}</label>
                      <input
                        type="text"
                        name={field.name}
                        className="hh-input"
                        placeholder="Type your address manually..."
                        value={formState[field.name] || ''}
                        onChange={handleInputChange}
                        style={{ marginBottom: '12px' }}
                      />
                      <LocationPicker onLocationSelect={handleLocationSelect} />
                    </div>
                  );
                }

                // Standard inputs for everything else
                return (
                  <div key={field.name} className="hh-field">
                    <label className="hh-label">{field.label}</label>
                    <input
                      type={field.type || 'text'}
                      name={field.name}
                      className="hh-input"
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                      value={formState[field.name] || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                );
              })}

              {/* The Submit Button is now securely locked inside the form flow */}
              <button type="submit" className="hh-submit-btn" disabled={saving}>
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </form>
          </div>
        )}

      </div>
    </>
  );
}